import { call, put } from 'redux-saga/effects';
import { ApiError } from 'store/api/types';
import { turnMessageOn } from 'store/app/actions';
import { checkResponse } from 'store/utils';
import { renderErrorMessage } from 'utils/render-error-message';
import { generateScanEmail, getScanEmailStatus } from '../api';
import { MessageData } from 'store/app/types';
import { logoutRequest } from 'store/auth/actions';
import { fetchAddUrlFailure, setScanEmail } from '../actions';

export function* generateScanEmailSaga(action: any) {
  try {
    const { connectionId } = action.payload;

    const response = yield call(generateScanEmail, connectionId);

    const err: ApiError | null = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(setScanEmail(response.data));
  } catch (error) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(fetchAddUrlFailure());
  }
}

export function* getScanEmailStatusSaga(action: any) {
  try {
    const { connectionId } = action.payload;

    const response = yield call(getScanEmailStatus, connectionId);

    const err: ApiError | null = checkResponse(response?.responseMessage);
    if (err) throw err;

    yield put(setScanEmail(response.data));
  } catch (error) {
    const message: MessageData | null = renderErrorMessage(error);
    if (message) {
      yield put(turnMessageOn(message));
    } else {
      yield put(logoutRequest());
    }
    yield put(fetchAddUrlFailure());
  }
}
